import * as React from 'react';
import { Route, HashRouter, Switch } from 'react-router-dom';
import  App  from './App';
import  About  from './components/about';
import  Home  from './components/home';
import  Contact  from './components/contact';

export const AppRouter: React.StatelessComponent<{}> = () => {
  return (
    <HashRouter>
      <div className="container-fluid">
        <Route component={App} />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route  path="/home" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
        </Switch>
      </div>
    </HashRouter>
  );
}